module.exports = __webpack_public_path__ + "img/icon-support.fb598bb5.svg";